import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#hn4ddgobh__clip0_small)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#yg1pni53n__clip1_small)",
          children: [_jsx("rect", {
            x: "0",
            y: "0.0",
            width: "20",
            height: "1.429",
            fill: "#CC0001"
          }), _jsx("rect", {
            x: "0",
            y: "2.857",
            width: "20",
            height: "1.429",
            fill: "#CC0001"
          }), _jsx("rect", {
            x: "0",
            y: "5.714",
            width: "20",
            height: "1.429",
            fill: "#CC0001"
          }), _jsx("rect", {
            x: "0",
            y: "8.571",
            width: "20",
            height: "1.429",
            fill: "#CC0001"
          }), _jsx("rect", {
            x: "0",
            y: "11.429",
            width: "20",
            height: "1.429",
            fill: "#CC0001"
          }), _jsx("rect", {
            x: "0",
            y: "14.286",
            width: "20",
            height: "1.429",
            fill: "#CC0001"
          }), _jsx("rect", {
            x: "0",
            y: "17.143",
            width: "20",
            height: "1.429",
            fill: "#CC0001"
          }), _jsx("rect", {
            x: "0",
            y: "0",
            width: "10.5",
            height: "11.429",
            fill: "#010066"
          }), _jsxs("g", {
            fill: "#FFCC00",
            children: [_jsx("path", {
              d: "M6.44 3.43 A3 3 0 1 0 6.44 8.17 A2.55 2.55 0 1 1 6.44 3.43 Z"
            }), _jsx("path", {
              d: "M8.00 3.90 L8.19 4.97 L8.82 4.09 L8.53 5.14 L9.49 4.62 L8.77 5.43 L9.85 5.38 L8.85 5.80 L9.85 6.22 L8.77 6.17 L9.49 6.98 L8.53 6.46 L8.82 7.51 L8.19 6.63 L8.00 7.70 L7.81 6.63 L7.18 7.51 L7.47 6.46 L6.51 6.98 L7.23 6.17 L6.15 6.22 L7.15 5.80 L6.15 5.38 L7.23 5.43 L6.51 4.62 L7.47 5.14 L7.18 4.09 L7.81 4.97 Z"
            })]
          })]
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "hn4ddgobh__clip0_small",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "yg1pni53n__clip1_small",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            fill: "white"
          })
        })]
      })]
    }))
  });
};
export default Component;
